import React from 'react';
import DeviceList from '../DevicesList/DeviceList';
import { useSelector } from "react-redux";
import { selectNavHeight } from "../../../../redux/navbar/navHeightSlice";


const InspectionDeviceList = () => {
      const navHeight = useSelector(selectNavHeight);
    
    return (
        <div  className="mx-auto w-full"
        style={{
          marginTop: navHeight,
          height: `calc(100vh - ${navHeight}px)`,
          overflow: "auto",
        }} >       
            <DeviceList />
        </div>
    );
};

export default InspectionDeviceList;